import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { Adjustment } from '../models/adjustment';
import { AdjustmentStore } from '../service/adjustment.store';

@Injectable()
export class AdjustmentResolver implements Resolve<any> {
  constructor(private adjustmentStore: AdjustmentStore,
              private translateService: TranslateService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<List<Adjustment>> {
    const id = route.params[ 'id' ];
    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_ADJUSTMENTS'));
    }

    return this.adjustmentStore.loadAdjustments(route.params[ 'id' ]).first();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/adjustment.resolver.ts